import { SortUtilities } from './Sort.utility';

const getMock: () => Partial<SortUtilities> = () => ({
    adjustSortDirection: (direction, sort) => sort,
    makeAlphabeticSort: (getProperty) => () => 1,
    makeDateSort: (getProperty) => () => 1
});

export const sortUtilitiesMock = {
    getMock,
    provider: (Service: typeof SortUtilities) => ({
        provide: Service,
        useValue: getMock()
    })
};
